// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vMd7","col":"styles_col__kTwsL"};